var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "example-full" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-danger float-right btn-is-option hidden",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.isOption = !_vm.isOption
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-cog", attrs: { "aria-hidden": "true" } }),
        _vm._v("\n    Options\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isOption,
            expression: "!isOption",
          },
        ],
        staticClass: "upload",
      },
      [
        _vm.files.length
          ? _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-hover" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    false && !_vm.files.length
                      ? _c("tr", [
                          _c("td", { attrs: { colspan: "7" } }, [
                            _c("div", { staticClass: "text-center p-5" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-lg btn-primary",
                                  attrs: { for: _vm.name },
                                },
                                [_vm._v("Select Files")]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.files, function (file, index) {
                      return _vm.files.length
                        ? _c("tr", { key: file.id }, [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              file.thumb
                                ? _c("img", {
                                    attrs: {
                                      src: file.thumb,
                                      width: "200",
                                      height: "auto",
                                    },
                                  })
                                : _c("span", [_vm._v("No Image")]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "filename" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(file.name) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              file.active || file.progress !== "0.00"
                                ? _c("div", { staticClass: "progress" }, [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "progress-bar": true,
                                          "progress-bar-striped": true,
                                          "bg-danger": file.error,
                                          "progress-bar-animated": file.active,
                                        },
                                        style: { width: file.progress + "%" },
                                        attrs: { role: "progressbar" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(file.progress) +
                                            "%\n              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(file.size))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(file.speed))]),
                            _vm._v(" "),
                            file.error
                              ? _c("td", [_vm._v(_vm._s(file.error))])
                              : file.success
                              ? _c("td", [_vm._v("success")])
                              : file.active
                              ? _c("td", [_vm._v("active")])
                              : _c("td"),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                file.id
                                  ? _c(
                                      "vue-ladda",
                                      {
                                        attrs: {
                                          "button-class":
                                            "btn btn-danger btn-sm",
                                          "data-style": "zoom-in",
                                          loading: _vm.removeLoading[index],
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeUploadedFile(
                                              file,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("удалить\n            ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "example-foorer" },
          [
            _c("div", { staticClass: "hidden footer-status float-right" }, [
              _vm._v(
                "\n        Drop: " +
                  _vm._s(_vm.$refs.upload ? _vm.$refs.upload.drop : false) +
                  ",\n        Active: " +
                  _vm._s(_vm.$refs.upload ? _vm.$refs.upload.active : false) +
                  ",\n        Uploaded: " +
                  _vm._s(_vm.$refs.upload ? _vm.$refs.upload.uploaded : true) +
                  ",\n        Drop active: " +
                  _vm._s(
                    _vm.$refs.upload ? _vm.$refs.upload.dropActive : false
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-group" },
              [
                !_vm.updateUploadFilesData
                  ? _c(
                      "file-upload",
                      {
                        ref: "upload",
                        staticClass: "btn btn-primary dropdown-toggle",
                        attrs: {
                          "post-action": _vm.postAction,
                          "put-action": _vm.putAction,
                          extensions: _vm.extensions,
                          accept: _vm.accept,
                          multiple: _vm.multiple,
                          directory: _vm.directory,
                          size: _vm.size || 0,
                          thread:
                            _vm.thread < 1
                              ? 1
                              : _vm.thread > 5
                              ? 5
                              : _vm.thread,
                          headers: _vm.headers,
                          data: _vm.data,
                          drop: _vm.drop,
                          "drop-directory": _vm.dropDirectory,
                          "add-index": _vm.addIndex,
                        },
                        on: {
                          "input-filter": _vm.inputFilter,
                          "input-file": _vm.inputFile,
                        },
                        model: {
                          value: _vm.files,
                          callback: function ($$v) {
                            _vm.files = $$v
                          },
                          expression: "files",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v("\n          Выбрать файл\n        "),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.allowToUpload
              ? [
                  !_vm.$refs.upload || !_vm.$refs.upload.active
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$refs.upload.active = true
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-arrow-up",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v("\n          Загрузить файлы\n        "),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$refs.upload.active = false
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-stop",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v("\n          Отмена\n        "),
                        ]
                      ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOption,
            expression: "isOption",
          },
        ],
        staticClass: "option",
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "accept" } }, [_vm._v("Accept:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.accept,
                expression: "accept",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", id: "accept" },
            domProps: { value: _vm.accept },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.accept = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Allow upload mime type"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "extensions" } }, [
            _vm._v("Extensions:"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.extensions,
                expression: "extensions",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", id: "extensions" },
            domProps: { value: _vm.extensions },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.extensions = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Allow upload file extension"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("PUT Upload:")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.putAction,
                    expression: "putAction",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "radio",
                  name: "put-action",
                  id: "put-action",
                  value: "",
                },
                domProps: { checked: _vm._q(_vm.putAction, "") },
                on: {
                  change: function ($event) {
                    _vm.putAction = ""
                  },
                },
              }),
              _vm._v("\n          Off\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.putAction,
                    expression: "putAction",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "radio",
                  name: "put-action",
                  id: "put-action",
                  value: "/upload/put",
                },
                domProps: { checked: _vm._q(_vm.putAction, "/upload/put") },
                on: {
                  change: function ($event) {
                    _vm.putAction = "/upload/put"
                  },
                },
              }),
              _vm._v(" On\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("After the shutdown, use the POST method to upload"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "thread" } }, [_vm._v("Thread:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.thread,
                expression: "thread",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", max: "5", min: "1", id: "thread" },
            domProps: { value: _vm.thread },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.thread = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v(
              "Also upload the number of files at the same time (number of threads)"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "size" } }, [_vm._v("Max size:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.size,
                expression: "size",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "0", id: "size" },
            domProps: { value: _vm.size },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.size = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "minSize" } }, [_vm._v("Min size:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.minSize,
                expression: "minSize",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "0", id: "minSize" },
            domProps: { value: _vm.minSize },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.minSize = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "autoCompress" } }, [
            _vm._v("Automatically compress:"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.autoCompress,
                expression: "autoCompress",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "0", id: "autoCompress" },
            domProps: { value: _vm.autoCompress },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.autoCompress = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _vm.autoCompress > 0
            ? _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v(
                  "More than " +
                    _vm._s(_vm.autoCompress) +
                    " files are automatically\n        compressed"
                ),
              ])
            : _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v("Set up automatic compression"),
              ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addIndex,
                    expression: "addIndex",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "add-index" },
                domProps: {
                  checked: Array.isArray(_vm.addIndex)
                    ? _vm._i(_vm.addIndex, null) > -1
                    : _vm.addIndex,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.addIndex,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.addIndex = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.addIndex = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.addIndex = $$c
                    }
                  },
                },
              }),
              _vm._v(" Start position to add\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Add a file list to start the location to add"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drop,
                    expression: "drop",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "drop" },
                domProps: {
                  checked: Array.isArray(_vm.drop)
                    ? _vm._i(_vm.drop, null) > -1
                    : _vm.drop,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.drop,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.drop = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.drop = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.drop = $$c
                    }
                  },
                },
              }),
              _vm._v(" Drop\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Drag and drop upload"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dropDirectory,
                    expression: "dropDirectory",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "drop-directory" },
                domProps: {
                  checked: Array.isArray(_vm.dropDirectory)
                    ? _vm._i(_vm.dropDirectory, null) > -1
                    : _vm.dropDirectory,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.dropDirectory,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.dropDirectory = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.dropDirectory = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.dropDirectory = $$c
                    }
                  },
                },
              }),
              _vm._v(" Drop directory\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Not checked, filter the dragged folder"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-check" }, [
            _c("label", { staticClass: "form-check-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.uploadAuto,
                    expression: "uploadAuto",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "upload-auto" },
                domProps: {
                  checked: Array.isArray(_vm.uploadAuto)
                    ? _vm._i(_vm.uploadAuto, null) > -1
                    : _vm.uploadAuto,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.uploadAuto,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.uploadAuto = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.uploadAuto = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.uploadAuto = $$c
                    }
                  },
                },
              }),
              _vm._v(" Auto start\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Automatically activate upload"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.isOption = !_vm.isOption
                },
              },
            },
            [_vm._v("Confirm\n      ")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: { modal: true, fade: true, show: _vm.addData.show },
        attrs: { id: "modal-add-data", tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [_vm._v("Add data")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.addData.show = false
                      },
                    },
                  },
                  [_c("span", [_vm._v("×")])]
                ),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onAddData.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v("Name:"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addData.name,
                            expression: "addData.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          required: "",
                          id: "name",
                          placeholder: "Please enter a file name",
                        },
                        domProps: { value: _vm.addData.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.addData, "name", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(2),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "type" } }, [
                        _vm._v("Type:"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addData.type,
                            expression: "addData.type",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          required: "",
                          id: "type",
                          placeholder: "Please enter the MIME type",
                        },
                        domProps: { value: _vm.addData.type },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.addData, "type", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(3),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "content" } }, [
                        _vm._v("Content:"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addData.content,
                            expression: "addData.content",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          required: "",
                          id: "content",
                          rows: "3",
                          placeholder: "Please enter the file contents",
                        },
                        domProps: { value: _vm.addData.content },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.addData,
                              "content",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.addData.show = false
                          },
                        },
                      },
                      [_vm._v("Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                      },
                      [_vm._v("Save")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: { modal: true, fade: true, show: _vm.editFile.show },
        attrs: { id: "modal-edit-file", tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [_vm._v("Edit file")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.editFile.show = false
                      },
                    },
                  },
                  [_c("span", [_vm._v("×")])]
                ),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onEditorFile.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v("Name:"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editFile.name,
                            expression: "editFile.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          required: "",
                          id: "name",
                          placeholder: "Please enter a file name",
                        },
                        domProps: { value: _vm.editFile.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.editFile, "name", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.editFile.show &&
                    _vm.editFile.blob &&
                    _vm.editFile.type &&
                    _vm.editFile.type.substr(0, 6) === "image/"
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Image: ")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-image" }, [
                            _c("img", {
                              ref: "editImage",
                              attrs: { src: _vm.editFile.blob },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-image-tool" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { role: "group" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      title: "cropper.rotate(-90)",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFile.cropper.rotate(-90)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-undo",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      title: "cropper.rotate(90)",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFile.cropper.rotate(90)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-repeat",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { role: "group" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      title: "cropper.crop()",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFile.cropper.crop()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-check",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      title: "cropper.clear()",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFile.cropper.clear()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-remove",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editFile.show = false
                          },
                        },
                      },
                      [_vm._v("Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                      },
                      [_vm._v("Save")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("№")]),
        _vm._v(" "),
        _c("th", [_vm._v("Preview")]),
        _vm._v(" "),
        _c("th", [_vm._v("Имя")]),
        _vm._v(" "),
        _c("th", [_vm._v("Размер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Скорость")]),
        _vm._v(" "),
        _c("th", [_vm._v("Статус")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _vm._v("Drop files anywhere to upload"),
      _c("br"),
      _vm._v("or"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("small", { staticClass: "form-text text-muted" }, [
      _vm._v("Such as "),
      _c("code", [_vm._v("filename.txt")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("small", { staticClass: "form-text text-muted" }, [
      _vm._v("Such as "),
      _c("code", [_vm._v("text/plain")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }